<template>
  <div class="equipments">
    <h1>{{ msg }}</h1>
  </div>
</template>

<script>
export default {
  name: 'ferti',
  created() {
    this.$emit('title-change', 'Equipamentos');
  },
  data () {
    return {
      msg: 'Equipamentos'
    }
  }
}
</script>


<style scoped>
</style>
